const domain = ['pknin.com', 'www.pknin.com'].includes(window.location.hostname);
export const API_URL = domain ? `${window.location.origin}/backend` : process.env.REACT_APP_API_URL;
export const SOCKET_URL = domain ? window.location.origin : process.env.REACT_APP_SOCKET_URL;
